// TMOS Admin Notification Entity Configuration
// Date: November 15, 2025
// Purpose: Entity definition for FlexibleCRUDTable

import { EntityDefinition } from '@/types/crud';

export const adminNotificationEntity: EntityDefinition = {
  name: 'admin_notifications',
  displayName: 'Admin Notifications',
  displayNameSingular: 'Admin Notification',
  apiEndpoint: '/notifications/admin',
  idField: 'id',
  nameField: 'title',
  fields: [
    {
      key: 'notification_type',
      name: 'notification_type',
      label: 'Type',
      type: 'select',
      required: true,
      options: [
        { value: 'SYSTEM_ANNOUNCEMENT', label: 'System Announcement' },
        { value: 'FEATURE_UPDATE', label: 'Feature Update' },
        { value: 'MAINTENANCE_NOTICE', label: 'Maintenance Notice' },
        { value: 'GENERAL', label: 'General' }
      ]
    },
    {
      key: 'title',
      name: 'title',
      label: 'Title',
      type: 'text',
      required: true
    },
    {
      key: 'message',
      name: 'message',
      label: 'Message',
      type: 'textarea',
      required: true
    },
    {
      key: 'is_active',
      name: 'is_active',
      label: 'Active',
      type: 'checkbox',
      defaultValue: true
    },
    {
      key: 'scheduled_start_time',
      name: 'scheduled_start_time',
      label: 'Scheduled Start',
      type: 'datetime'
    },
    {
      key: 'scheduled_end_time',
      name: 'scheduled_end_time',
      label: 'Scheduled End',
      type: 'datetime'
    },
    {
      key: 'created_at',
      name: 'created_at',
      label: 'Created At',
      type: 'datetime',
      readOnly: true,
      hidden: true
    },
    {
      key: 'updated_at',
      name: 'updated_at',
      label: 'Updated At',
      type: 'datetime',
      readOnly: true,
      hidden: true
    }
  ]
};


